Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconEditData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M18.22 2.92l2.86 2.86L7.16 20H4v-3.16L18.22 2.92zm0-2.41a1 1 0 00-.7.28L2 16v4a1.84 1.84 0 001.89 2H8L23.2 6.47a1 1 0 000-1.4L18.93.81a1 1 0 00-.71-.29V.51z' fill='currentColor' fill-rule='nonzero'/%3e%3cpath d='M13.33 5.02l5.65 5.65M5.03 13.31l5.66 5.66' stroke='currentColor' stroke-width='2'/%3e%3c/g%3e%3c/svg%3e",
  iconEditWidth: 24,
  iconEditHeight: 24
};